module.exports = __webpack_public_path__ + "img/filter.153af6ea.svg";